import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import $ from 'jquery';
import SettingsPage from '../../views/SettingsPage/';
const GLOBAL = require('../../Globals');

class Academic extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			id : '',
			startyear : '',
			startmonth : '',
			endyear : '',
			endmonth : '',
			yearstatus : '',
			_message : '',
			value : '',
			alertClass :'',
			_redirect : '',
			posts : []
		}
		/** bind function **/
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.onClick = this.onClick.bind(this);
	}
	
	/** set value **/
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
	}
	
	/** reset the form **/
	onClick(e){
		
		document.getElementById("acyearform").reset();
	}
	
	/** remove function **/
	handleClick(dd){
		
		this.state.id = dd;
		console.log('id'+this.state.id);
		
		if (window.confirm("Do you want to Delete?")) {
			 $("#showLoader").show();
			PostData('academic/deleteacyear',this.state).then((result) => {
				 $("#showLoader").hide();
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'Academic Year Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove Academic Year',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}
	
	/** submit form **/
	onSubmit(e){
		e.preventDefault();
		
		this.state.endyear = $("#eyear").val();
		
		if(this.state.startyear && this.state.startmonth && this.state.endyear && this.state.endmonth ){
			
			PostData('academic/add',this.state).then((result) => {
				let responseJson = result;
				if(responseJson.status == '1' ){
					this.setState({
						_message:'Academic Year Added Successfully!..',
						alertClass:'alert alert-success',
					});
					document.getElementById("acyearform").reset();
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Already Added',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}
	
	/** this function will be call when page loading **/
	componentWillMount() {
		 
		this.getdata();
	}
	
	getdata(){
		
		GetData('academic/getacyear').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
				
			}
			
		});
	}
	
	/** pass id to update value **/
	onUpdate(dt){
		
		this.state.idd = dt;
		this.setState({_redirect: true});
		
	}
	
  render() {
	  
	/** get year only select box **/
	const currentYear = new Date().getFullYear();
	const fromMonth = new Date(currentYear - 1, 0);
	const toMonth = new Date(currentYear + 10, 11);
	
	const years = [];
	  for (let i = fromMonth.getFullYear(); i <= toMonth.getFullYear(); i += 1) {
		years.push(i);
	}
	
	/** set month in select box **/
	  this.month = [
		{value : '', name: 'Select Month'},
		{value : 'January', name: 'January'},
		{value : 'February', name: 'February'},
		{value : 'March', name: 'March'},
		{value : 'April', name: 'April'},
		{value : 'May', name: 'May'},
		{value : 'June', name: 'June'},
		{value : 'July', name: 'July'},
		{value : 'August', name: 'August'},
		{value : 'September', name: 'September'},
		{value : 'October', name: 'October'},
		{value : 'November', name: 'November'},
		{value : 'December', name: 'December'}
	];
	
	/** set status select box **/
	this.acyearstatus = [
		{value : '', name : 'Select'},
		{value : 'Active', name : 'Active'},
		{value : 'Deactive', name : 'Deactive'}
	];
	
	/** Redirect to update page **/
	if(this.state._redirect){
		  
		return (<Redirect to={'/settings/academicupdate/'+this.state.idd} />);

	}
	
	$("#syear").change(function(){
		
		var sr = $(this).val();
		var er = parseInt(sr)+1;
		$("#eyear").val(er);
	});
	
    return (
		<div>
		  <SettingsPage />
			<div className="animated fadeIn">
				<Row>
				  <Col md="6">
					<div className={this.state.alertClass}>
						{this.state._message}
					</div>
					<Card>
					  <form action="" method="post" role="form" id="acyearform" encType="multipart/form-data" onSubmit={this.onSubmit}>
						<CardHeader>
							<strong>Academic Details</strong>
						</CardHeader>
						<CardBody>
							<Row>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Start Year</Label>
								  <select name="startyear" className="form-control" id="syear" onChange={this.onChange} required>
									<option value="">Select Year</option>
									{years.map(year => (
									  <option key={year} value={year}>
										{year}
									  </option>
									))}
								  </select>
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Start Month</Label>
								  <select name="startmonth" className="form-control" onChange={this.onChange} required>
									{this.month.map((e, key) => {
										return <option key={key} value={e.value}>{e.name}</option>;
									})}		
								 </select>
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">End Year</Label>
								  <input type="text" name="endyear" className="form-control" onChange={this.onChange} id="eyear" disabled />
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">End Month</Label>
								  <select name="endmonth" className="form-control" onChange={this.onChange} required>
									{this.month.map((e, key) => {
										return <option key={key} value={e.value}>{e.name}</option>;
									})}	
								 </select>
								</FormGroup>
							  </Col>
							  <Col md="12">
								<FormGroup>
								  <Label htmlFor="name">Active / Deactive</Label>
								  <select name="yearstatus" className="form-control" onChange={this.onChange} required>
									{this.acyearstatus.map((e, key) => {
										return <option key={key} value={e.value}>{e.name}</option>;
									})}	
								 </select>
								</FormGroup>
							  </Col>
							</Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
							<Button type="reset" size="sm" color="danger" onClick={this.onClick}><i className="fa fa-ban"></i> Reset</Button>
						</CardFooter>
					  </form>
					</Card>
				  </Col>
				  <Col md="6">
				   <Card>
					<CardBody>
					<Table responsive bordered>
						<thead>
							<tr>
								<th>S.No</th>
								<th>Start Year</th>
								<th>Start Month</th>
								<th>End Year</th>
								<th>End Month</th>
								<th>Status</th>
								<th width="100">Manage</th>
							</tr>
						</thead>
						<tbody>
							{this.state.posts.map(item =>
							 
								<tr key = {item}>
									<td>{item.id}</td>
									<td>{item.startyear}</td>
									<td>{item.startmonth}</td>
									<td>{item.endyear}</td>
									<td>{item.endmonth}</td>
									<td>{item.yearstatus}</td>
									<td>
										<button name="editacyear" className="btn btn-info btn-sm" onClick={() => this.onUpdate(item.id)} data-toggle="tooltip" data-placement="top" title="Edit" ><i className="fa fa-edit"></i></button>
										&nbsp;&nbsp;
										<button name="removesub" className="btn btn-danger btn-sm" onClick={() => this.handleClick(item.id)} data-toggle="tooltip" data-placement="top" title="Delete" ><i className="fa fa-remove"></i></button>
									</td>
								</tr>
				  
							 )}
						</tbody>
					</Table>
					</CardBody>
				   </Card>
				  </Col>
				</Row>
			</div>
		</div>
	)
  }
}

export default Academic;



// WEBPACK FOOTER //
// ./src/settings/Academic/Academic.js